import type { ReactNode } from "react";
import { HoverCard, HoverCardPopup } from "../../ui/hover-card";

/**
 * What a button will do, said before it is pressed — a hover card, not a
 * browser tooltip: readable, styled, and able to hold two sentences.
 */
export function ActionHint({
  heading,
  body,
  children,
}: {
  readonly heading: string;
  readonly body: ReactNode;
  readonly children: ReactNode;
}) {
  return (
    <HoverCard>
      {children}
      <HoverCardPopup side="bottom" align="end" className="w-72 px-3.5 py-3">
        <p className="text-xs font-semibold text-foreground">{heading}</p>
        <div className="mt-1 space-y-1.5 text-xs leading-5 text-muted-foreground">{body}</div>
      </HoverCardPopup>
    </HoverCard>
  );
}
